import api from './api';
import { API_ROUTES } from '@/lib/constants';
import { createCrudService, createSubResourceGetter } from './crud.factory';
import type { Contact, Activity, Note, Deal, Email, Task } from '@/types/table';

export const contactService = {
  ...createCrudService<Contact>(API_ROUTES.CONTACTS),

  bulkDelete: async (ids: string[]) => {
    await api.post(`${API_ROUTES.CONTACTS}/bulk-delete`, { ids });
  },

  getActivities: createSubResourceGetter<Activity>(API_ROUTES.CONTACTS, 'activities'),
  getNotes: createSubResourceGetter<Note>(API_ROUTES.CONTACTS, 'notes'),
  getDeals: createSubResourceGetter<Deal>(API_ROUTES.CONTACTS, 'deals'),
  getEmails: createSubResourceGetter<Email>(API_ROUTES.CONTACTS, 'emails'),
  getTasks: createSubResourceGetter<Task>(API_ROUTES.CONTACTS, 'tasks'),
};
